<template>
  <footer class="footer" id="foto-footer">
    <!-- <div i-class="text-center text-white pt-20" class="footer-search">
      <h3 i-class="fz-20 fw-bold">Free PNG Images Gallery</h3>
      <p i-class="fz-14 mt-20">
        Free millions of high quality transprent PNG images for your website,
        design or presentation
      </p>
      <AutoCompleteSearch
        class="footer-search-input"
        i-class="mt-20"
        search
        autoComplete
      />
    </div> -->
    <div class="footer-container">
      <div class="col self" i-class="text-center">
        <div class="logo">
          <a href="/">
            <img
              width="162.5"
              height="25"
              :src="cdnUrl + '/sharkfoto_logo_white.svg'"
              alt=""
            />
          </a>
        </div>
        <p>AI Make Photo Editing Different</p>
        <div class="copyright">
          <p>Copyright © 2025 SharkFoto</p>
          <ul class="icons">
            <li>
              <a class="pr-icon" href="https://www.pinterest.com/sharkfoto/">
                <i class="iconfont icon-pinterest" i-class="text-white"> </i>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/SharkFoto-100253106125543">
                <img
                  width="28"
                  height="28"
                  :src="cdnUrl + '/social_ico_facebook.svg'"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/Shark_Foto">
                <img
                  width="28"
                  height="28"
                  :src="cdnUrl + '/social_ico_twitter.svg'"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/sharkfoto">
                <img
                  width="28"
                  height="28"
                  :src="cdnUrl + '/social_ico_linkedin.svg'"
                  alt=""
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col" v-for="f in footerList" :key="f.title">
        <div i-class="fz-16 fw-bold" class="col-title">
          {{ f.title }}
        </div>
        <div class="col-container">
          <p v-for="(s, idx) in f.children" :key="s.href + idx">
            <a :href="s.href">{{ s.title }}</a>
          </p>
        </div>
      </div>
      <div class="empty"></div>
    </div>
    <div class="m-self" i-class="text-center">
      <div class="logo">
        <a href="/">
          <img
            width="162.5"
            height="25"
            :src="cdnUrl + '/sharkfoto_logo_white.svg'"
            alt=""
          />
        </a>
      </div>
      <p>AI Make Photo Editing Different</p>
      <div class="copyright">
        <p>Copyright © 2025 SharkFoto</p>
        <ul class="icons">
          <li>
            <a class="pr-icon" href="https://www.pinterest.com/sharkfoto/">
              <i class="iconfont icon-pinterest" i-class="text-white"> </i>
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/SharkFoto-100253106125543">
              <img
                width="28"
                height="28"
                :src="cdnUrl + '/social_ico_facebook.svg'"
                alt=""
              />
            </a>
          </li>
          <li>
            <a href="https://twitter.com/Shark_Foto">
              <img
                width="28"
                height="28"
                :src="cdnUrl + '/social_ico_twitter.svg'"
                alt=""
              />
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/sharkfoto">
              <img
                width="28"
                height="28"
                :src="cdnUrl + '/social_ico_linkedin.svg'"
                alt=""
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- <TrackImage /> -->
  </footer>
</template>

<script>
import { footerList } from "@/settings/footer";
// import TrackImage from "@/components/common/TrakeSvg.vue";
const cdnUrl = __CDN_URL__;
export default {
  name: "AppFooter",
  // components: {
  //   TrackImage,
  // },
  data() {
    return {
      footerList,
      cdnUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer,
div,
h3,
span,
a,
ul,
li,
img {
  box-sizing: border-box;
}
.footer {
  width: 100%;
  position: relative;
  height: auto;
  background-color: #282828;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  .icons {
    margin-top: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      width: 28px;
      height: 28px;
      a {
        display: block;
        width: 28px;
        height: 28px;
      }
      img {
        width: 28px;
        height: 28px;
      }
    }
    li:not(:first-child) {
      margin-left: 8px;
    }
    .pr-icon {
      width: 28px;
      height: 28px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #4f4f4f;
      i {
        font-size: 16px;
      }
    }
  }
  .m-self {
    width: 100%;
    margin-top: 20px;
    padding: 50px 0 20px;
    border-top: 1px solid #343434;
    p {
      margin-top: 14px;
    }
    display: none;
  }
  a {
    transition: 0.2s;
    color: #e7e7e7;
    &:hover {
      color: $linkHoverColor;
    }
  }
  &-search {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 18px;
    padding-bottom: 30px;
    border-bottom: 1px solid #343434;
    .footer-search-input {
      width: 100%;
      max-width: 708px;
      :deep(.input-with-select) {
        max-width: 708px;
      }
      :deep(.history-pannel) {
        max-width: 708px;
      }
    }
  }
  &-container {
    max-width: 1280px;
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0;
    margin: 0 auto;
    .col {
      width: 15%;
      display: flex;
      flex-direction: column;
      p {
        margin-top: 14px;
      }
      &-title {
        color: #e7e7e7;
        &::after {
          content: "";
          display: block;
          width: 30px;
          margin-top: 5px;
          border: 1px solid white;
        }
      }
    }
    .self {
      width: 25%;
      margin-top: -20px;
      align-items: center;
      justify-content: center;
      color: #e7e7e7;
    }
  }
}
@media only screen and (max-width: 980px) {
  .footer {
    .m-self {
      display: block;
    }
    &-container {
      padding: 20px 32px;
      justify-content: space-between;
      .col {
        width: calc((100% - 64px) / 3);
        &:nth-child(n + 5) {
          margin-top: 15px;
        }
      }
      .empty {
        width: calc((100% - 64px) / 3);
      }

      .self {
        display: none;
      }
    }
  }
}
@media only screen and (max-width: 560px) {
  .footer {
    &-container {
      padding: 20px 34px;
      justify-content: space-between;
      .col {
        width: calc((100% - 64px) / 2);
        &:nth-child(n + 4) {
          margin-top: 20px;
        }
      }
      .empty {
        width: calc((100% - 64px) / 2);
      }
    }
  }
}
</style>
